import React, { useEffect, useState } from 'react'
import { Card, Col, Row } from "antd"
import { DashboardDetailIcon, DashboardDetailType } from '../utils'
import { Icon } from '@iconify/react';
import { Const } from '@mods/constants';
import { trans } from '../../../wrappers/components';

const languageKey = Const["dashboard"].lngKey;

const filteredCriteria = [
  DashboardDetailType.ACTIVE_SAAS,
  DashboardDetailType.INACTIVE_SAAS,
  DashboardDetailType.ACTIVE_OUTLETS,
  DashboardDetailType.INACTIVE_OUTLETS,
  DashboardDetailType.ACTIVE_DEVICES,
  DashboardDetailType.INACTIVE_DEVICES
]

export default function DashboardMainSummary({ records }) {
  const [filteredData, setFilteredData] = useState([])

  useEffect(() => {
    const filteredData = records.filter(record => filteredCriteria.includes(record.type))
    setFilteredData(filteredData)
  }, [records])


  const SummaryCard = ({ record, flag }) => {
    return (
      < Col xs={ 24 } sm={ 6 } lg={ 4 } >
        <Card
          hoverable
          style={ { borderRadius: '8px', textAlign: 'center' } }
        >
          <div className="user-status">
            <Icon icon={ DashboardDetailIcon[record.type] } fontSize={ 40 } color={ flag ? '#52c41a' : '#ff4d4f' } />
            <h3>{ trans(`${languageKey}.${record.type}`) }</h3>
            <span>{ record.value }</span>
          </div>
        </Card>
      </ Col>
    )
  }

  return (
    <div>
      <div style={ { padding: '20px', background: '#f0f2f5', marginTop: "20px" } }>
        <Row gutter={ 16 }>
          {
            filteredData.map((record, index) => (
              <SummaryCard record={ record } flag={ index % 2 === 0 } key={ record.type } />
            ))
          }
        </Row>
      </div>
    </div>
  )
}
